export enum KmlLayer {
  Airfields = 'airfields',
  ProtectedAreas = 'protectedAreas',
}